import React, { useState } from "react";
import { useRouter } from "@/lib/navigation";
import MegaPipe from "@/lib/MegaPipe";
import { componentsList } from "@/lib/widgetComponentsDir";
import NotificationsTray from "@/components/shellComponents/NotificationsTray";
import featureFlagStore from "@/store/featureFlagStore";

interface WidgetToJSXProps {
  cryptoID: string | undefined;
  loadedFromPopout: boolean;
  esidToPass: string;
}

const Popout = () => {
  const router = useRouter();
  const { component, esid } = router.query;
  const ComponentName = component;

  const [esidToPass, setEsidToPass] = useState(""); // esidToPass: string = "";
  if (esid !== undefined && esidToPass == "") {
    setEsidToPass(esid.toString());
  }

  let ComponentNameString = "";
  if (component != undefined) {
    ComponentNameString = component.toString();
  }

  const WidgetToJSX: React.FC<WidgetToJSXProps> =
    componentsList[ComponentNameString];

  // Gate the trade tile until this window's feature flags resolve. The grid configures the
  // settings cog/sidebar in useMemo calls that run once on first mount, so the flags must be
  // known before the tile renders — otherwise the cog/sidebar miss that first mount (LQC-1724).
  const featureFlagsLoaded = featureFlagStore((state) => state.featureFlagsLoaded);
  if (ComponentName == "TradeTile" && !featureFlagsLoaded) {
    return <div className=" m-3 h-screen w-full bg-slate-100 dark:bg-black" />;
  }

  return (
    <div className=" m-3 h-screen w-full bg-slate-100 dark:bg-black">
      {ComponentName == "TradeTile" && esidToPass != undefined ? (
        <WidgetToJSX
          cryptoID={undefined} // no need to pass cryptoID when using Pop out.
          loadedFromPopout={true} // Passing true will use the ESID rather than the logic to get it off the ID
          esidToPass={esidToPass}
        />
      ) : ComponentName == "NotificationsTray" ? (
        <div className=" bg-[#EBEBEB]">
          <NotificationsTray />
        </div>
      ) : (
        <div></div>
      )}
      <MegaPipe />
    </div>
  );
};

export default Popout;
